import { useClient } from "@/composables/useClient";
import { deserializeCbiDto, serializeCbiDto, encodeRequestParam } from "../serialization/CbiDateCodec";
import type { GuestPrivilegeApi } from "../../api/GuestPrivilegeApi";
import type { GuestPrivilegeFetchOptions } from "../../generated/dto/GuestPrivilegeFetchOptions";
import type { GuestPrivilegeStaff } from "../../generated/dto/GuestPrivilegeStaff";
import type { MembershipStaff } from "../../generated/dto/MembershipStaff";
import type { MembershipStaffFetchOptions } from "../../generated/dto/MembershipStaffFetchOptions";

export class GuestPrivilegeApiClient implements GuestPrivilegeApi {
  constructor(private readonly client = useClient()) {}

  async getGuestPrivilegeStaff(id: number, options?: GuestPrivilegeFetchOptions): Promise<GuestPrivilegeStaff> {
    const { data } = await this.client.get<unknown>(`/guestprivilege/staff/${id}`, { params: serializeCbiDto(options, "generated.dto.GuestPrivilegeFetchOptions") });
    return deserializeCbiDto<GuestPrivilegeStaff>(data, "generated.dto.GuestPrivilegeStaff");
  }

  async getGuestPrivilegeStaffMembershipId(id: number, options?: MembershipStaffFetchOptions): Promise<MembershipStaff> {
    const { data } = await this.client.get<unknown>(`/guestprivilege/staff/${id}/membershipid`, { params: serializeCbiDto(options, "generated.dto.MembershipStaffFetchOptions") });
    return deserializeCbiDto<MembershipStaff>(data, "generated.dto.MembershipStaff");
  }
}

export const useGuestPrivilegeApi = (): GuestPrivilegeApi => new GuestPrivilegeApiClient();
